import { useRef, useState } from 'react';
import { useInterval } from 'react-use';
import { isBrowser } from 'src/libs/wa/utils/env';

export const TEST_GROUP_PATTERN = 1;
const EXPERIMENT_ID = process.env.NEXT_PUBLIC_OPTIMIZE_NEXT_EXPERIMENT_ID;
const MAX_TRY = 60;
const REFETCH_TIME = 500;

export const useOptimizeNext = () => {
  const [optimizeNextPattern, setOptimizeNextPattern] = useState<number | undefined>(undefined);
  const tryCountRef = useRef(0);

  useInterval(
    () => {
      if (isBrowser() && window?.optimize_next) {
        setOptimizeNextPattern(window.optimize_next.get(EXPERIMENT_ID ?? ''));
      }
      tryCountRef.current += 1;
    },
    !optimizeNextPattern && tryCountRef.current <= MAX_TRY ? REFETCH_TIME : null
  );

  return optimizeNextPattern;
};
